import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

const features = [
  {
    icon: "menu_book",
    title: "Strong Academic Program",
    description: "Comprehensive curriculum designed to develop critical thinking and academic skills.",
  },
  {
    icon: "record_voice_over",
    title: "English-Speaking Environment",
    description: "Full English medium instruction to build strong communication skills.",
  },
  {
    icon: "groups",
    title: "Dedicated Teachers",
    description: "Qualified and passionate educators committed to student success.",
  },
  {
    icon: "child_care",
    title: "Child-Friendly Campus",
    description: "Safe spaces designed for learning, play, and holistic development.",
  },
  {
    icon: "desktop_windows",
    title: "Computer Laboratory",
    description: "Modern computer lab introducing students to digital literacy.",
  },
  {
    icon: "psychology",
    title: "Holistic Development",
    description: "Focus on academic, social, emotional, and spiritual growth.",
  },
];

function KeyFeatures() {
  return (
    <MKBox component="section" py={6}>
      <Container>
        <Grid container justifyContent="center" sx={{ textAlign: "center", mb: 4 }}>
          <Grid item xs={12} md={8}>
            <MKTypography variant="h3" mb={1}>
              What We Offer
            </MKTypography>
            <MKTypography variant="body1" color="text">
              A comprehensive educational experience designed for your child&apos;s success.
            </MKTypography>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          {features.map((feature, index) => (
            <Grid item xs={12} md={6} lg={4} key={index}>
              <MKBox display="flex" alignItems="flex-start" p={2}>
                <MKBox
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  width="3rem"
                  height="3rem"
                  borderRadius="lg"
                  sx={{
                    backgroundColor: "#006747",
                    flexShrink: 0,
                    mr: 2,
                  }}
                >
                  <Icon sx={{ color: "#d32f2f" }}>{feature.icon}</Icon>
                </MKBox>
                <MKBox>
                  <MKTypography variant="h6" mb={0.5}>
                    {feature.title}
                  </MKTypography>
                  <MKTypography variant="body2" color="text">
                    {feature.description}
                  </MKTypography>
                </MKBox>
              </MKBox>
            </Grid>
          ))}
        </Grid>
      </Container>
    </MKBox>
  );
}

export default KeyFeatures;
